import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { changeSort }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleSortEntry = useCallback(async (index, direction) => {
    await changeSort(index, direction)
    await handleRefresh()
  }, [changeSort, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleSortEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleSortEntry])
}
